import { render, staticRenderFns } from "./MkObjPopupTableInfo6.vue?vue&type=template&id=5938cbb2&"
import script from "./MkObjPopupTableInfo6.vue?vue&type=script&lang=js&"
export * from "./MkObjPopupTableInfo6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports